export const PROFILE_FORM_NAME = 'profileForm'
export const TIME_PREFERENCES_FORM = 'timePreferencesForm'
export const PROFILE_AVATAR_FORM_NAME = 'profileAvatarForm'
export const WHY_YOU_STOP_PROTRACK_FORM_NAME = 'whyYouStopProTrackPopupForm'
export const WHY_YOU_CHANGE_PROPTRACK_FORM_NAME = 'whyYouChangeProTrackPopupForm'
export const SWITCH_PROTRACK_FROM_EMAIL = 'SWITCH_PROTRACK_FROM_EMAIL'
export const WORK_WEEK_DEFAULT = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri']
export const WORK_WEEK_EVERY_OTHER_DAY = ['Mon', 'Wed', 'Fri']
export const WORK_WEEK_TWICE_A_WEEK = ['Mon', 'Wed']
export const WORK_WEEK_ONCE_A_WEEK = ['Mon']
